import { render } from "./SendOrderFailedModal.vue?vue&type=template&id=190a481a&scoped=true"
import script from "./SendOrderFailedModal.vue?vue&type=script&lang=js"
export * from "./SendOrderFailedModal.vue?vue&type=script&lang=js"

import "./SendOrderFailedModal.vue?vue&type=style&index=0&id=190a481a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190a481a"]])

export default __exports__